const navData = {
  Home: [
    [
      {
        title: "Home",
        route: "/",
      },
      {
        title: "About",
        route: "/about",
      },
      {
        title: "Sending Organizations",
        route: "/sending",
      },
      {
        title: "Capacity Building",
        route: "/capacity-projects",
      },

      {
        title: "Current programs",
        route: "/programs",
        isHighlighted: true,
        children: [
          { title: "All Programs", route: "/programs" },
          {
            title: "Volunteering",
            route: "/programs" + "?tab=Volunteering",
            hook: "Volunteering",
          },
          {
            title: "Roadtrips",
            route: "/programs" + "?tab=Roadtrips",
            hook: "Roadtrips",
          },
          {
            title: "Junior Camps",
            route: "/programs" + "?tab=Junior+Camps",
            hook: "Junior Camps",
          },
          {
            title: "EU Programs",
            route: "/programs" + "?tab=EU+Programs",
            hook: "EU Programs",
          },
        ],
      },
    ],
    [
      {
        title: "Sign In",
        route: "/login",
      },
    ],
    [
      {
        title: "Profile",
        route: "/profile/" + localStorage.getItem("id"),
      },
      {
        title: "Log Out",
        route: "/login",
      },
    ],
    [
      {
        title: "Log Out",
        route: "/login",
      },
      {
        title: "Admin Center",
        route: "/admin",
      },
    ],
  ],
};

export default navData;
